import type { ModuleKey } from "@gaole/shared";
import { useAuth } from "../stores/auth";
import { PageLoader } from "./ui";
import { ModuleComingSoon } from "./storefront/ModuleComingSoon";

export function RequireModule({ module, children }: { module: ModuleKey; children: React.ReactNode }) {
  const loading = useAuth((s) => s.loading);
  const moduleEnabled = useAuth((s) => s.moduleEnabled);

  if (loading) return <PageLoader />;
  if (!moduleEnabled(module)) return <ModuleComingSoon module={module} />;
  return <>{children}</>;
}
